var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5,1C6.2,1,1,6.2,1,12.5S6.2,24,12.5,24S24,18.8,24,12.5S18.8,1,12.5,1z M13.6,18.2h-2.3V16h2.3C13.7,16,13.7,18.2,13.6,18.2z M13.6,13.6h-2.3V6.8h2.3C13.7,6.8,13.7,13.6,13.6,13.6z"
  })));
};
export default SvgError;